import React from 'react';

export const SearchIcon = ({ size }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='icon icon-tabler icon-tabler-search'
    width={size}
    viewBox='0 0 24 24'
    strokeWidth='1.5'
    stroke='#000000'
    fill='none'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path stroke='none' d='M0 0h24v24H0z' />
    <circle cx='10' cy='10' r='7' />
    <line x1='21' y1='21' x2='15' y2='15' />
  </svg>
);

export const ThemeIcon = () => (
  <svg
    version='1.1'
    id='Capa_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='16px'
    height='16px'
    viewBox='0 0 534.18 534.18'
  >
    <g>
      <g>
        <path
          d='M118.309,328.676c25.016,60.432,83.44,99.477,148.845,99.477c14.137,0,28.069-1.891,41.643-5.553
			c0.539-0.145,1.077-0.297,1.613-0.447c6.169-1.734,12.271-3.797,18.268-6.279c82.042-33.959,121.158-128.33,87.198-210.366
			c-25.013-60.432-83.438-99.48-148.841-99.48c-21.139,0-41.839,4.134-61.524,12.283c-39.744,16.451-70.698,47.39-87.17,87.125
			C101.867,245.168,101.858,288.936,118.309,328.676z M138.128,213.635c14.278-34.449,41.117-61.273,75.57-75.536
			c17.078-7.068,35.021-10.652,53.336-10.652c56.707,0,107.359,33.856,129.049,86.252c29.373,70.965-4.324,152.559-75.117,182.17
			c4.061-28.369,0.45-57.078-10.704-84.029c-28.497-68.847-100.294-108.422-172.323-97.706
			C138.003,213.968,138.061,213.8,138.128,213.635z'
        />
        <path
          d='M140.377,115.28c1.913,1.487,4.235,2.258,6.582,2.258c1.383,0,2.775-0.266,4.094-0.814l91.858-38.021
			c3.562-1.472,6.056-4.746,6.533-8.568c0.477-3.822-1.135-7.607-4.223-9.912L167.376,2.127c-3.026-2.258-7.014-2.757-10.502-1.312
			s-5.958,4.614-6.502,8.351l-14.012,96.118C135.806,109.096,137.339,112.915,140.377,115.28z'
        />
        <path
          d='M455.478,242.91c1.472,3.562,4.746,6.056,8.568,6.533c0.446,0.055,0.89,0.083,1.331,0.083
			c3.354,0,6.545-1.576,8.583-4.305l58.094-77.843c2.256-3.023,2.754-7.014,1.312-10.502c-1.44-3.488-4.614-5.958-8.351-6.502
			l-96.117-14.015c-3.819-0.56-7.629,0.976-9.997,4.018c-2.368,3.042-2.919,7.117-1.444,10.676L455.478,242.91z'
        />
        <path
          d='M373.216,534.18c1.383,0,2.775-0.268,4.094-0.814c3.488-1.445,5.958-4.615,6.503-8.352l14.015-96.117
			c0.557-3.812-0.979-7.629-4.018-9.996c-3.039-2.363-7.118-2.916-10.677-1.445l-91.858,38.023
			c-3.562,1.473-6.056,4.746-6.532,8.568c-0.478,3.822,1.135,7.607,4.223,9.912l77.843,58.094
			C368.687,533.457,370.941,534.18,373.216,534.18z'
        />
        <path
          d='M9.168,383.811l96.118,14.012c0.517,0.074,1.031,0.113,1.545,0.113c0.021,0,0.043,0,0.064,0
			c5.912-0.004,10.704-4.795,10.704-10.711c0-1.848-0.468-3.588-1.294-5.105L78.7,291.273c-1.472-3.562-4.746-6.057-8.568-6.533
			c-3.837-0.48-7.61,1.135-9.912,4.223L2.126,366.809c-2.255,3.023-2.754,7.014-1.312,10.502S5.435,383.266,9.168,383.811z'
        />
        <path
          d='M291.363,78.716l91.84,38.066c1.322,0.548,2.715,0.817,4.101,0.817c2.344,0,4.663-0.768,6.576-2.255
			c3.041-2.366,4.577-6.181,4.023-9.994L383.94,9.227c-0.544-3.736-3.011-6.91-6.499-8.354s-7.479-0.946-10.502,1.307
			l-77.874,58.057c-3.088,2.301-4.703,6.086-4.226,9.909C285.313,73.967,287.805,77.242,291.363,78.716z'
        />
        <path
          d='M473.947,289.064c-2.304-3.088-6.086-4.703-9.908-4.227c-3.825,0.475-7.096,2.969-8.57,6.527l-38.066,91.84
			c-1.476,3.559-0.925,7.637,1.44,10.676c2.044,2.629,5.178,4.135,8.452,4.135c0.511,0,1.025-0.037,1.542-0.111l96.124-13.965
			c3.733-0.545,6.906-3.012,8.354-6.5c1.444-3.488,0.949-7.475-1.307-10.502L473.947,289.064z'
        />
        <path
          d='M249.347,464.037c-0.474-3.824-2.968-7.096-6.527-8.57L150.98,417.4c-3.565-1.475-7.641-0.928-10.676,1.441
			c-3.042,2.365-4.578,6.182-4.024,9.994l13.966,96.127c0.544,3.732,3.011,6.906,6.5,8.354c1.322,0.547,2.714,0.816,4.1,0.816
			c2.271,0,4.526-0.723,6.402-2.123l77.874-58.059C248.209,471.645,249.821,467.859,249.347,464.037z'
        />
        <path
          d='M60.236,245.119c2.038,2.732,5.229,4.309,8.586,4.309c0.441,0,0.881-0.028,1.325-0.083
			c3.825-0.475,7.096-2.968,8.571-6.527l38.066-91.84c1.475-3.559,0.924-7.638-1.441-10.676c-2.366-3.042-6.181-4.578-9.994-4.024
			L9.226,150.244c-3.733,0.545-6.907,3.011-8.354,6.5c-1.444,3.489-0.949,7.476,1.307,10.502L60.236,245.119z'
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

export const RightChevronIcon = ({ size }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='icon icon-tabler icon-tabler-chevron-right'
    width={size}
    viewBox='0 0 24 24'
    strokeWidth='1.5'
    stroke='#000000'
    fill='none'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path stroke='none' d='M0 0h24v24H0z' />
    <polyline points='9 6 15 12 9 18' />
  </svg>
);

export const GameControllerIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='icon icon-tabler icon-tabler-device-gamepad'
    width='16'
    height='16'
    viewBox='0 0 24 24'
    strokeWidth='1.5'
    stroke='#000000'
    fill='none'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path stroke='none' d='M0 0h24v24H0z' />
    <rect x='2' y='6' width='20' height='12' rx='2' />
    <path d='M6 12h4m-2 -2v4' />
    <line x1='15' y1='11' x2='15' y2='11.01' />
    <line x1='18' y1='13' x2='18' y2='13.01' />
  </svg>
);
